import React, { useEffect, useState } from 'react';

const SearchableDropdown = ({ recruiterData,selectedRecruiter,setSelectedRecruiter,selectedRecruiterId,setSelectedRecruiterId }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const recruiterDataActive = recruiterData.filter(item=>item.isActive === true);
    const filteredRecruiters = recruiterDataActive.filter((r) =>
        `${r.firstName} ${r.lastName}`.toLowerCase().includes(searchTerm.toLowerCase())
    );

   

    return (
        <div className="relative w-full font-mont text-[16px] m-4">
            <div
                className="field_bg border-[#C8D6E6] border focus:outline-none text-sm rounded-lg block p-2.5 h-12 pr-10 flex items-center cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className={`font-[500] text-[14px] ${selectedRecruiter ? 'text-black' : 'text-gray-400'}`}>
                    {selectedRecruiter || 'Select Recruiter'}
                </span>
                <span className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`transform transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    >
                        <path
                            d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                            stroke="#245CEA"
                            strokeWidth="2"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </span>
            </div>

            {isOpen && (
                <div className="absolute z-10 bg-white border border-[#C8D6E6] rounded-lg mt-2 shadow-lg w-full">
                    <input
                        type="text"
                        className="field_bg border-b border-[#C8D6E6] focus:outline-none text-sm rounded-t-lg block w-full p-2.5 h-12 font-mont font-[500] text-[14px]"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <ul className="max-h-48 overflow-y-auto">
                        {filteredRecruiters.length > 0 ? (
                            filteredRecruiters.map((r) => (
                                <li
                                    key={r.recruiterID}
                                    className="p-2 font-mont font-[500] text-[14px] hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                        setSelectedRecruiter(`${r.firstName} ${r.lastName}`);
                                        setSelectedRecruiterId(r.recruiterID)
                                        setSearchTerm('');
                                        setIsOpen(false);
                                    }}
                                >
                                    {r.firstName} {r.lastName}
                                </li>
                            ))
                        ) : (
                            <li className="p-2 font-mont font-[500] text-[14px] text-gray-400">
                                No recruiters found
                            </li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default SearchableDropdown;
